import React from "react";
import "./SectionStrategyCTANew.css";

export default function SectionStrategyCTANew() {
  return (
    <section className="cta-section">

      {/* ── Left — cream panel, full-bleed ── */}
      <div className="cta-left">
        <h2 className="cta-title">
          <span className="cta-title-accent">Strategy</span> is
          <br />
          The Common Thread
          <br />
          Across Everything We Do.
        </h2>

        <p className="cta-desc">
          Whether the requirement is animation, visual production,
          branding, digital experiences, or content, every engagement
          begins with understanding the business objective behind it.
        </p>

        <p className="cta-tagline">
          Clarity informs strategy. Strategy informs execution.
        </p>
      </div>

      {/* ── Right — gold panel, full-bleed ── */}
      <div className="cta-right">
        <h3 className="cta-right-title">
          Let&apos;s Start With Your Business Objective.
        </h3>

        <a
          href="https://www.eilandigital.com"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-link-btn"
        >
          www.eilandigital.com
        </a>
      </div>

    </section>
  );
}